'use client';

import { fadDoNotEnter } from '@/icons/doNotEnter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppContext, AuthContext } from '@inway/layout';
import Link from 'next/link';
import { useContext } from 'react';
import { useTranslation } from './i18n/client';

export default function NotFound() {
  const { i18n, theme } = useContext(AppContext);
  const { t } = useTranslation(i18n?.lng);
  const { userId } = useContext(AuthContext);

  const logoUrl = theme.logo.src ?? '/logo.svg';

  return (
    <div className="container">
      <nav className="navbar navbar-dark">
        <Link href="/" className="navbar-brand">
          <img src={logoUrl} alt="Brand logo" width="90" height="90" />
        </Link>
        {userId ? (
          <Link href="/dashboard" className="btn btn-primary">
            {t('Show dashboard')}
          </Link>
        ) : (
          <Link href="/login" className="btn btn-primary">
            {t('Sign In')}
          </Link>
        )}
      </nav>
      <div className="d-flex flex-column jusity-content-start align-items-center gap-4 mt-4">
        <FontAwesomeIcon icon={fadDoNotEnter} size="6x" />
        <h2>{t('Not Found')}</h2>
        <p>{t('Could not find requested resource')}</p>
      </div>
    </div>
  );
}
